export function flattenCategoryTree(categories = []) {
  const source = Array.isArray(categories) ? categories : [];
  const byParent = new Map();
  source.forEach(category => {
    const parentKey = category.parent_id == null ? 'root' : String(category.parent_id);
    byParent.set(parentKey, [...(byParent.get(parentKey) || []), category]);
  });
  const compare = (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
    || String(a.name || '').localeCompare(String(b.name || ''), 'ru');
  byParent.forEach(items => items.sort(compare));

  const result = [];
  const visited = new Set();
  const append = (category, depth, path) => {
    const id = String(category.id);
    if (visited.has(id)) return;
    visited.add(id);
    const nextPath = [...path, category];
    result.push({
      ...category,
      tree_depth: depth,
      path_label: category.path_label || nextPath.map(item => item.name).join(' › '),
    });
    (byParent.get(id) || []).forEach(child => append(child, depth + 1, nextPath));
  };

  (byParent.get('root') || []).forEach(category => append(category, 0, []));
  source.filter(category => !visited.has(String(category.id))).sort(compare)
    .forEach(category => append(category, 0, []));
  return result;
}

export function descendantCategoryIds(categories = [], categoryId) {
  const result = new Set([String(categoryId)]);
  let changed = true;
  while (changed) {
    changed = false;
    categories.forEach(category => {
      if (category.parent_id != null && result.has(String(category.parent_id)) && !result.has(String(category.id))) {
        result.add(String(category.id));
        changed = true;
      }
    });
  }
  return result;
}

export function canUseCategoryAsParent(categories = [], candidateId, categoryId) {
  if (candidateId == null) return true;
  if (String(candidateId) === String(categoryId)) return false;
  return !descendantCategoryIds(categories, categoryId).has(String(candidateId));
}
